import "./sparkle_namespace.js";

window.Sparkle ??= {};

window.Sparkle.Accessibility = {
  ignored: ".uber_select, :input",

  clickableWithKeyboard(container) {
    jQuery(container).on("keyup", "[tabindex]", Sparkle.Accessibility.handleKeyboardClick);

    return container;
  },

  handleKeyboardClick(event) {
    if (event.key !== "Enter") {
      return;
    }
    if (jQuery(event.target).closest(Sparkle.Accessibility.ignored).length) {
      return;
    }

    event.stopPropagation();

    return jQuery(event.target).trigger("click");
  },
};
